<template>
<div class="contents">
  <admin adminType="staff" :id="id" :searchPrm="searchPrm"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminWashRequestDateChange.vue'
export default {
  name: 'staff-wash-request-date-change',
  props: {
    id: {
      type: [String, Number],
      default: -1
    },
    searchPrm: {
      type: Object,
      'default': () => ({
        staffId: '',
        createdDtFrom: '',
        createdDtTo: '',
        filterWreqCreated: false,
        filterPickedUp: false,
        filterWashed: false,
        filterFolded: false,
        filterDelivered: false,
        userId: '',
        bagSize:'',
      })
    }
  },
  components: {
    Admin
  }
}
</script>